import { toast } from "react-toastify";

// Wrapper for dynamic toast messages
export const showToast = (
  type: "success" | "error" | "info" | "warning",
  message: string
) => {
  const finalMessage =
    message || "Unable to complete the action. Please check and try again.";

  const id = finalMessage;

  // Prevent duplicate toasts
  if (toast.isActive(id)) {
    toast.dismiss(id);
  }

  const options = {
    position: "bottom-center" as const,
    autoClose: 3000,
    toastId: id,
  };

  switch (type) {
    case "success":
      toast.success(finalMessage, options);
      break;
    case "error":
      toast.error(finalMessage, options);
      break;
    case "info":
      toast.info(finalMessage, options);
      break;
    case "warning":
      toast.warning(finalMessage, options);
      break;
    default:
      break;
  }
};